import { post } from './api';
import { handleError } from './errors';
import GrapeFormat from './formatters/formik-grape-formatter';

const STRATEGIC_REC_VIEWED = 'strategic_recommendation_viewed';
const STRATEGIC_REC_ACCEPTED = 'strategic_recommendation_accepted';
const STRATEGIC_REC_DECLINED = 'strategic_recommendation_declined';
const STRATEGIC_REC_STORY_CLICKED = 'strategic_recommendation_story_clicked';
const STRATEGIC_REC_HELP_LINK_CLICKED = 'strategic_recommendation_help_link_clicked';

export {
  STRATEGIC_REC_VIEWED,
  STRATEGIC_REC_ACCEPTED,
  STRATEGIC_REC_DECLINED,
  STRATEGIC_REC_STORY_CLICKED,
  STRATEGIC_REC_HELP_LINK_CLICKED
};

export const logAuditEvent = (eventName, options) => {
  const formattedOptions = JSON.stringify(
    GrapeFormat({
      event_name: eventName,
      options
    })
  );

  return post('/api/v1/audit_events', formattedOptions)
    .then(response => response)
    .catch(error => handleError(error));
};


// Takes in a constant and an object of options and logs event in mixpanel
const logMixpanelEvent = (eventName, options) => window.mixpanel.track(eventName, options);

export default logMixpanelEvent;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/log_events.js